import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { useSelector } from 'react-redux';
import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
import { permissionObj } from '../../../../../Helpers/permission';

/**
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const SubViewOptions = ({ subView, changeSubViewManage }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { isAttendanceSupervisor } = useSelector((state) => state.AttendancePersistSlice);
    const allowAll = DEV || isAttendanceSupervisor;

    return (
        <div className='d-flex gap-3'>
            {(allowAll || permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ)) && (
                <ButtonAction
                    id='btn_svo_period_review'
                    name='period_review'
                    className={
                        ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.PERIOD_REVIEW === subView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.PERIOD_REVIEW);
                    }}
                />
            )}

            {(allowAll || permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_REQUEST_READ)) && (
                <ButtonAction
                    id='btn_svo_request'
                    name='adjustments_request'
                    className={
                        ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.REQUESTED === subView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.REQUESTED);
                    }}
                />
            )}

            {(allowAll || permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_HISTORY_READ)) && (
                <ButtonAction
                    id='btn_svo_history'
                    name='adjustments_history'
                    className={
                        ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.HISTORY === subView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.HISTORY);
                    }}
                />
            )}
        </div>
    );
};

export default SubViewOptions;
